import type { Dispatch, SetStateAction } from 'react'
import { useState } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

import Page from '@/components/layouts/Page'
import WholesaleTabs from '@/features/wholesale/pages/components/WholesaleTabs'
import type { Breadcrumb } from '@/types/breadcrumb'

export type WholesalePageConfig = {
  title: string
  breadcrumbs: Breadcrumb[]
  pageTag?: string
  activeTab: string
}

type ContextType = {
  pageConfig: WholesalePageConfig | null
  setPageConfig: Dispatch<SetStateAction<WholesalePageConfig | null>>
}

function WholesaleLayout() {
  const [pageConfig, setPageConfig] = useState<WholesalePageConfig | null>(null)

  const pageHeaderProps = pageConfig
    ? {
        pageTitle: pageConfig.title,
        breadcrumbItems: pageConfig.breadcrumbs,
        pageTag: pageConfig.pageTag,
      }
    : undefined

  return (
    <Page pageHeaderProps={pageHeaderProps}>
      {pageConfig?.activeTab && <WholesaleTabs activeTab={pageConfig.activeTab} />}
      <Outlet context={{ pageConfig, setPageConfig } satisfies ContextType} />
    </Page>
  )
}

export function useWholesaleLayout() {
  return useOutletContext<ContextType>()
}

export default WholesaleLayout
